import { useEffect, useState } from "react";

const HotelCardSkeleton: React.FC = () => {
  const [displayCards, setDisplayCards] = useState<number>(4);

  const updateDisplayedHotels = () => {
    const isLargeScreen = window.innerWidth >= 1536;
    const isMediumScreen = window.innerWidth >= 1024;
    if (isLargeScreen) {
      setDisplayCards(5);
    } else if (isMediumScreen) {
      setDisplayCards(4);
    } else {
      setDisplayCards(4);
    }
  };

  useEffect(() => {
    updateDisplayedHotels();
    window.addEventListener('resize', updateDisplayedHotels);

    return () => {
      window.removeEventListener('resize', updateDisplayedHotels);
    };
  }, []);

  return (
    <section>
      <div className="animate-pulse flex justify-between">
        {Array.from({ length: displayCards }).map((_, index) => (
          <div key={index} className="mb-6">
            <div className="relative h-80 w-64 bg-gray-300 rounded-md">
              <div className="w-full h-full object-cover object-center bg-gray-300"></div>
            </div>

            <div className="pt-2 rounded-b-md w-64 mt-2 items-center">
              <div className="flex space-x-1">
                <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
                <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              </div>
            </div>

            <div className="mt-2 w-64 h-4 bg-gray-300 rounded"></div>

            <div className="mt-2 w-48 h-4 bg-gray-300 rounded"></div>

            <div className="mt-2 w-64 flex justify-between items-center">
              <div className="w-20 h-6 bg-gray-300 rounded"></div>
              <div className="w-24 h-6 bg-gray-300 rounded"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HotelCardSkeleton;